import { Row as AntdRow, RowProps } from 'antd';
import { FunctionComponent } from 'react';

export type { RowProps };

export const Row: FunctionComponent<RowProps> = (props) => {
  return <AntdRow className="the5ers-row" {...props} />;
};
